require('/src/com/yext/listingslaunchstorm/js/components/styles/matchentity.module.scss.module.css');

export const calloutWarning = "_callout-warning_1rdxn_1";
